import { entityDeepLink, entityKindLabel, entityRefFromSubject, type EntityRef } from "./entityDeepLink";
import { ViewEntityButton } from "../preview/ViewEntityButton";
import type { AuditScope, AuditSubject } from "@/services/api/guardiansv2/types";
import type { ScopeLabelCache } from "../audits/useScopeLabelCache";

export interface EntityLinkProps {
  subject: AuditSubject;
  scope: AuditScope;
  scopeLabels?: ScopeLabelCache;
  title?: string | null;
  className?: string;
}

function resolveDisplayName(
  ref: EntityRef,
  scopeLabels: ScopeLabelCache | undefined,
  fallbackTitle: string | null | undefined
): string {
  if (fallbackTitle?.trim()) return fallbackTitle.trim();
  const { kind, scope, id } = ref;
  if (kind === "mission") {
    return scopeLabels?.missionLabel(scope.mission_id ?? id) ?? `View ${entityKindLabel(kind)}`;
  }
  if (kind === "task") {
    return scopeLabels?.taskLabel(scope.task_id ?? id) ?? `View ${entityKindLabel(kind)}`;
  }
  return `View ${entityKindLabel(kind)}`;
}

/** Named deep link with hover preview for a Guardians entity. */
export function EntityLink({
  subject,
  scope,
  scopeLabels,
  title,
  className,
}: EntityLinkProps) {
  const ref = entityRefFromSubject(subject, scope, title);
  if (!ref) return null;

  const label = resolveDisplayName(ref, scopeLabels, title ?? ref.title);
  const link = entityDeepLink(ref);
  if (!link) return <span className={className}>{label}</span>;

  return (
    <ViewEntityButton
      entity={{ ...ref, title: label }}
      label={label}
      variant="inline"
      className={className}
      previewPlacement="left"
    />
  );
}
